/* eslint-disable no-underscore-dangle */
/* eslint-disable no-case-declarations */
import { toast } from "react-toastify";
import {
  GET_TABLE,
  GET_CARD,
  GET_BUILDING,
  CHECK_OUT,
  GET_TABLE_SOCKET,
  GET_VISITOR_HISTORY
} from "../action/constant";

const initialState = {
  tableData: [],
  loading: false,
  err: {},
  cardData: {},
  buildingData: [],
  // Own flags for the building list so other actions sharing `loading`/`err`
  // can't make the select screen spin or hide its error.
  buildingLoaded: false,
  buildingErr: null,
  totalPage: 1,
  totalDoc: 0,
  record: {
    open: false,
    row: {},
    history: [],
    visitCount: 0,
    historyLoading: false
  }
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case 'VISITOR_RECORD_OPEN':
      return {
        ...state,
        record: {
          open: true,
          row: action.row || {},
          history: [],
          visitCount: 0,
          historyLoading: true
        }
      };

    case 'VISITOR_RECORD_CLOSE':
      return {
        ...state,
        record: {
          open: false,
          row: {},
          history: [],
          visitCount: 0,
          historyLoading: false
        }
      };

    case GET_VISITOR_HISTORY.SUCCESS:
      return {
        ...state,
        record: {
          ...state.record,
          historyLoading: false,
          history: action.data.visitors || [],
          visitCount: action.data.totaldocuments || 0
        }
      };

    case GET_VISITOR_HISTORY.ERROR:
      return {
        ...state,
        record: {
          ...state.record,
          historyLoading: false
        }
      };

    case GET_TABLE.PENDING:
      return {
        ...state,
        loading: true,
        err: {}
      };
    case GET_TABLE.SUCCESS:
      return {
        ...state,
        loading: false,
        tableData: action.data.visitors,
        totalPage: action.data.lastpage,
        totalDoc: action.data.totaldocuments
      };
    case GET_TABLE.ERROR:
      return {
        ...state,
        loading: false,
        err: action.err
      };
    case GET_CARD.PENDING:
      return {
        ...state,
        loading: true,
        err: {}
      };
    // Two things dispatch this: the REST Visitor/count call on mount, and the
    // websocket's "getData" frame on every visitor event. They do not carry the
    // same keys — the socket payload has no denied7Days — so this merges rather
    // than replaces. A replace made the Denied card flash its real value and
    // then drop to 0 the moment a socket frame arrived.
    case GET_CARD.SUCCESS:
      return {
        ...state,
        loading: false,
        cardData: { ...state.cardData, ...action.data },
        err: {}
      };
    case GET_CARD.ERROR:
      return {
        ...state,
        loading: false,
        err: action.err
      };
    case GET_BUILDING.PENDING:
      return {
        ...state,
        loading: true,
        err: {},
        buildingLoaded: false,
        buildingErr: null
      };
    case GET_BUILDING.SUCCESS:
      return {
        ...state,
        loading: false,
        err: {},
        buildingData: Array.isArray(action.data) ? action.data : [],
        buildingLoaded: true,
        buildingErr: null
      };
    case GET_BUILDING.ERROR:
      return {
        ...state,
        loading: false,
        err: action.err,
        buildingLoaded: true,
        buildingErr: action.err || {}
      };
    case CHECK_OUT.PENDING:
      return {
        ...state,
        loading: true,
        err: {}
      };
    case CHECK_OUT.SUCCESS:
      toast.success("Checked Out Successfully");
      return {
        ...state,
        err: {}
      };

    case CHECK_OUT.ERROR:
      toast.error("Error While Check Out");
      return {
        ...state,
        loading: false,
        err: action.err
      };
    case GET_TABLE_SOCKET.SUCCESS:
      let data = [];
      if (action.data.length !== 0) {
        if (state.tableData.length >= 10) {
          state.tableData.pop();
        }
        data = [...action.data, ...state.tableData];
      } else {
        data = state.tableData;
      }
      return {
        ...state,
        tableData: data
      };
    default:
      return state;
  }
}
